import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"definition-list__divider\" data-test-definition-list-divider>\n</div>")